<script>
  import { format } from 'svelte-i18n';
  import { Button } from '@sveltestrap/sveltestrap';

  import {
    Field,
    FieldActions,
    FieldError,
    FieldHeader,
    FieldLabel,
    FieldValue
  } from '@client/components/fields/standalone/base';
  import { Icon } from '@client/components/icon';
  import { Input } from '@client/components/input';

  export let id = null;
  export let label = null;
  export let value = null;
  export let displayValue = '••••••••••••';
  export let allowCopy = false;
  export let reveal = false;
  export let revealing = false;
  export let validationError = undefined;

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let ref = null;
  export let readonly = false;
  export let editing = false;

  export let showActions = true;

  export let onUpdate = () => {};
  export let onReveal = () => {};

  let newValue = value;
  let disableSubmit = true;
  let error = false;
  let visible = false;

  const onEdit = () => {
    editing = true;
    setTimeout(() => ref && ref.focus(), 100);
  };

  const onCancel = () => {
    editing = false;
    newValue = value;
  };

  const onSave = () => {
    value = newValue;
    editing = false;

    if (onUpdate) {
      onUpdate(id, label, value);
    }
  };

  const onToggleVisibility = () => {
    visible = !visible;
  };

  const revealPassword = () => {
    revealing = !revealing;
    onReveal();
  };

  $: disableSubmit = value === newValue;
  $: newValue = value;
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} bind:error />
    <FieldActions
      bind:readonly
      bind:editing
      bind:disableSubmit
      {onSave}
      {onEdit}
      {onCancel}
      {showActions}
      {allowCopy}
      bind:copyValue={newValue}
    />
  </FieldHeader>
  <FieldValue {showActions}>
    <div class="password-field">
      {#if editing}
        {#if !visible}
          <Input {id} type="password" class="raw" bind:ref bind:value={newValue} />
        {:else}
          <Input {id} type="text" class="raw" bind:ref bind:value={newValue} />
        {/if}
        <Icon
          name={visible ? 'eye' : 'eye-off'}
          class="pointer"
          on:click={onToggleVisibility}
          role="button"
          tabindex="0"
        />
      {:else}
        {#if !reveal}
          {@html newValue ? displayValue : '-'}
        {:else}
          <span>
            {#if revealing}
              {@html newValue}
            {:else}
              {@html newValue ? displayValue : '-'}
            {/if}
          </span>
        {/if}

        {#if reveal}
          <Icon
            name={revealing ? 'eye' : 'eye-off'}
            class="pointer"
            on:click={revealPassword}
            role="button"
            tabindex="0"
          />
        {/if}
      {/if}
    </div>
  </FieldValue>
  <FieldError bind:error {validationError} />
  {#if !editing}
    <slot />
  {/if}
</Field>

<style lang="scss" src="./password.scss"></style>
